// ThankYouStep.js
import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const ThankYouStep = () => {
  return (
    <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
      <CheckCircleIcon sx={{ fontSize: 60, color: 'green', mb: 2 }} />
      <Typography variant="h5" gutterBottom>
        Thank You for Your Feedback!
      </Typography>
      <Typography variant="body1">
        Your response has been successfully submitted. Your feedback helps us improve our services.
      </Typography>
    </Paper>
  );
};

export default ThankYouStep;